interface BlogData {
  relatedArticles?: Array<{ headerImage?: string }>;
}

export function normalizeBlogData(data: BlogData) {
  return {
    ...data,
    relatedArticles:
      data.relatedArticles &&
      data.relatedArticles.map(article => ({
        ...article,
        image: article.headerImage,
      })),
  };
}
